import { DirectoryData } from '../typing';
import useStyles from '../style';
import classNames from 'classnames';
import React, { useMemo } from 'react';
import { DownOutlined, RightOutlined } from '@ant-design/icons';
interface TiledDirectoryTitleProps {
    data: DirectoryData;
    isExpanded: boolean;
    onToggle: (e: React.MouseEvent<HTMLSpanElement>) => void;
    onTitleClick: (e: React.MouseEvent<HTMLDivElement>) => void;
    selectedTitle?: number;
}

// 目录标题组件
export const TiledDirectoryTitle: React.FC<TiledDirectoryTitleProps> = ({
    data,
    isExpanded,
    onToggle,
    onTitleClick,
    selectedTitle
}) => {
    const { styles } = useStyles();

    // 判断是否存在子列表
    const hasSubList = useMemo(() => data.SubList && data.SubList.length > 0, [data.SubList]);

    // 点击事件
    const onClick = (e: React.MouseEvent<HTMLDivElement>) => {
        e.stopPropagation();
        if (hasSubList) {
            onToggle(e);
        } else {
            onTitleClick(e);
        }
    };

    return (
        <div className={styles.directoryContainer} onClick={onClick}>
            <div className={
                classNames(styles.categoryTitle, {
                    [styles.categoryTitleHover]: selectedTitle !== data.CategoryId,
                    [styles.categoryTitleActive]: selectedTitle === data.CategoryId
                })
            }>  
                {data.CategoryName}
            </div>
            {hasSubList && (
                <span className={styles.triangleIcon} >
                    {isExpanded ?  <DownOutlined style={{ fontSize: 12 }} /> : <RightOutlined style={{ fontSize: 12 }} />}
                </span>
            )}
        </div>
    );
}; 